export const SOCIAL_URLS = {
  instagram: '',
  linkedin: '',
  facebook: 'https://www.facebook.com/share/17DiVtjqfL/',
  x: '',
  youtube: 'https://www.youtube.com/@Neuralia369',
  tiktok: 'https://www.tiktok.com/@carlosvargasvazquez?_r=1&_t=ZN-954HeTSX0pa',
};

export const SOCIAL_SAME_AS = Object.values(SOCIAL_URLS).filter(Boolean);
